import type { FaireProductEntity } from "../../entity_types/product";

export const p_bys2grkfzq: FaireProductEntity = {
  token: "p_bys2grkfzq",
  type: "product",
  name: "Behind the Times Belated Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/d8052776b88e4ee9d645abdcf29d233781848f06302be91a3d2f4fea8ff3c0bb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e837ac26dc84a491a5950cfa8d0bbd7a43713a8d48fe95ce212da776546f2940.jpeg",
    "https://cdn.faire.com/fastly/46028691c7db88a5391ef7ca383d4264ec0458353a605834a81dd73c775175af.jpeg",
  ],
  priceDollars: 3,
  description:
    "Sorry I'm so late, I was trying to source a slick roll of paper for my machine.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:18.294Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
